<div class="menu-container">
    <div
        data-cy="sys-status-side-menu-overview-button"
        class="menu-option"
        (click)="displaySelectedPage('overview')"
        [ngClass]="{ selected: selectedPage === 'overview' }"
    >
        {{ "system-status.page-title.overview" | translate }}
        <div
            data-cy="sys-status-side-menu-overview-alarm-counter"
            class="alarm-counts"
            *ngIf="getAlarmCounts(systemStatusData) > 0"
        >
            {{ getAlarmCounts(systemStatusData) }}
        </div>
    </div>
    <div
        data-cy="sys-status-side-menu-eap-button"
        class="menu-option"
        (click)="displaySelectedPage('eap')"
        [ngClass]="{ selected: selectedPage === 'eap' }"
    >
        {{ "system-status.page-title.eap" | translate }}
        <div
            data-cy="sys-status-side-menu-eap-alarm-counter"
            class="alarm-counts"
            *ngIf="getAlarmCounts(systemStatusData.eap) > 0"
        >
            {{ getAlarmCounts(systemStatusData.eap) }}
        </div>
    </div>
    <div
        data-cy="sys-status-side-menu-ops-button"
        class="menu-option"
        (click)="displaySelectedPage('ops')"
        [ngClass]="{ selected: selectedPage === 'ops' }"
    >
        {{ "system-status.page-title.ops" | translate }}
        <div
            data-cy="sys-status-side-menu-ops-alarm-counter"
            class="alarm-counts"
            *ngIf="getAlarmCounts(systemStatusData.ops) > 0"
        >
            {{ getAlarmCounts(systemStatusData.ops) }}
        </div>
    </div>
    <div
        data-cy="sys-status-side-menu-fcu-button"
        class="menu-option"
        (click)="showFcuList = !showFcuList; displaySelectedPage('fcu')"
        [ngClass]="{ selected: selectedPage === 'fcu' && !selectedFcuSrc }"
    >
        <mat-icon
            class="arrow-icon"
            svgIcon="system-status-menu-arrow"
            [ngStyle]="{ transform: showFcuList ? 'rotate(90deg)' : '' }"
        >
        </mat-icon>
        {{ "system-status.page-title.fcu" | translate }}
        <div
            data-cy="sys-status-side-menu-fcu-alarm-counter"
            class="alarm-counts"
            *ngIf="getAlarmCounts(systemStatusData.fcu) > 0"
        >
            {{ getAlarmCounts(systemStatusData.fcu) }}
        </div>
    </div>
    <div *ngIf="showFcuList">
        <div
            data-cy="sys-status-side-menu-distinct-fcu-button"
            class="menu-option submenu"
            *ngFor="let fcu of systemStatusData.fcu | keyvalue; index as i"
            [ngClass]="{ selected: selectedFcuSrc === fcu.key }"
            (click)="selectFcu(fcu)"
        >
            {{ "system-status.page-title.fcu" | translate }}
            {{ " " + getFcuIndex(fcu.key) }}
            <div
                data-cy="sys-status-side-menu-distinct-fcu-alarm-counter"
                class="alarm-counts"
                *ngIf="getAlarmCounts(fcu.value) > 0"
            >
                {{ getAlarmCounts(fcu.value) }}
            </div>
        </div>
    </div>
    <div
        data-cy="sys-status-side-menu-comm-button"
        class="menu-option"
        (click)="showCommsList = !showCommsList; displaySelectedPage('comms')"
        [ngClass]="{ selected: selectedPage === 'comms' && !selectedCommIF }"
    >
        <mat-icon
            class="arrow-icon"
            svgIcon="system-status-menu-arrow"
            [ngStyle]="{ transform: showCommsList ? 'rotate(90deg)' : '' }"
        >
        </mat-icon>
        {{ "system-status.page-title.comms" | translate }}
        <div
            data-cy="sys-status-side-menu-comm-alarm-counter"
            class="alarm-counts"
            *ngIf="getAlarmCounts(systemStatusData.comms) > 0"
        >
            {{ getAlarmCounts(systemStatusData.comms) }}
        </div>
    </div>
    <div *ngIf="showCommsList">
        <div
            data-cy="sys-status-side-menu-distinct-comm-button"
            class="menu-option submenu"
            *ngFor="let comm of systemStatusData.comms; index as i"
            [ngClass]="{ selected: selectedCommIF === comm }"
            (click)="selectCommIF(comm)"
        >
            {{ "system-status.page-title.comms" | translate }}
            {{ " " + (i + 1) }}
            <div
                data-cy="sys-status-side-menu-distinct-comm-alarm-counter"
                class="alarm-counts"
                *ngIf="getAlarmCounts(comm) > 0"
            >
                {{ getAlarmCounts(comm) }}
            </div>
        </div>
    </div>
    <div
        data-cy="sys-status-side-menu-printers-button"
        class="menu-option"
        (click)="displaySelectedPage('printers')"
        [ngClass]="{ selected: selectedPage === 'printers' }"
    >
        {{ "system-status.page-title.printers" | translate }}
        <div
            data-cy="sys-status-side-menu-printers-alarm-counter"
            class="alarm-counts"
            *ngIf="getAlarmCounts(systemStatusData.printers) > 0"
        >
            {{ getAlarmCounts(systemStatusData.printers) }}
        </div>
    </div>
</div>
